import React, { useCallback } from "react";

import { PMIResult } from "../../forms/custom-pmi/pmiResultForm";
import { getResultActionOptions } from "../../../utils/data";
import { matchPhrases } from "../../../utils/utilities";

import CustomSection from "../custom-general/custom-section";
import css from '../../themed/pdf/pdf.module.scss';

interface Props {
    elements: string[]
    pmiResultItems: PMIResult[];
}

const PMIResultTable: React.FC<Props> = ({ elements, pmiResultItems }) => {
    const getResultStyle = useCallback((item: PMIResult) => {
        const option = getResultActionOptions().find((option) => matchPhrases(option.id, item.result));
        
        if (option) {
            return {
                backgroundColor: option.color,
                color: '#FFFFFF',
            }
        }

        return {
            backgroundColor: '#000000',
            color: '#FFFFFF',
        }
    }, []);

    return (
        <CustomSection sectionTitle="Result">
            <div className="p-1">
                <div className="table-responsive">
                    <table className={css['pdf-table']}>
                        <thead>
                            <tr>
                                <th rowSpan={2}>Sr. No</th>
                                <th rowSpan={2}>Item Description</th>
                                <th colSpan={elements.length}>Elements</th>
                                <th rowSpan={2}>Identified Material Spec.</th>
                                <th rowSpan={2}>Result</th>
                            </tr>

                            <tr>
                                {elements.map((element) => (
                                    <th key={element}>{element}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {pmiResultItems.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.itemDescription}</td>

                                    {elements.map((element) => (
                                        <td key={element}>{item[element]}</td>
                                    ))}

                                    <td>{item.identifiedMaterialSpec}</td>
                                    <td style={getResultStyle(item)}>{item.result}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </CustomSection>
    );
};
 
export default PMIResultTable;